export const AboveBar = "above";
export const InsideBar = "inside";
export const BelowBar = "below";
